export default {
  "Callout": "_Callout_l78ft_1"
};import "ni:sha-256;GSDER7twC9CJv1j-Gm2M3v8313LkdbEx8gtb6p_UtyI";